module.exports = __webpack_public_path__ + "assets/img/companyLogo.192793bc.png";